import { flatten } from 'components/TreeSelect';
import { dateToFormat } from 'helpers/formatters/date';
import { Column } from 'react-table';
import { CompositeReturnTimeWindow } from 'types/CompositeReturn';
import { TagDefinition } from 'types/TagRefDefinition';
import { Api } from '../../../api';
import { formatToDate } from 'helpers/date';

export type RowType = {
  fromDate: string;
  selectionSet: string;
  property: string;
  propertyValue: string;
};

export const getRowFormatted = (row: any) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      selectionSet: row.assetSelectionSet,
      property: row.tagRefPropertyDefinition,
      propertyValue: row.propertyValue,
      isTimeWindowEnable: true,
    },
  };
};

export const useTable = (
  data: Array<CompositeReturnTimeWindow>,
  onDeleteRow?: (fromDate: string) => void
) => {
  const { data: assets } = Api.lookup.GetAssetSelectionSets();
  const { data: tagRef } = Api.lookup.GetTagRefPropertyDefinitions();

  const columns: Column[] = [
    {
      Header: 'From Date',
      accessor: 'fromDate',
    },
    {
      Header: 'To Date',
      accessor: 'toDate',
    },
    {
      Header: 'Selection Set',
      accessor: 'assetSelectionSet',
    },
    {
      Header: 'Property',
      accessor: 'tagRefPropertyDefinition',
    },
    {
      Header: 'Property Value',
      accessor: 'propertyValue',
    },
  ];

  const actionDeleteRow = (onCloseModal: any, row: any) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  return {
    data: data
      ? data?.map((item: CompositeReturnTimeWindow) => {
          const propDef =
            tagRef?.find(
              (tag: TagDefinition) =>
                +tag.id === +item.tagRefPropertyDefinitionId
            ) ?? [];
          const tags = flatten(propDef.tags ?? []);
          const propValue =
            tags?.find((tag: TagDefinition) => +tag.id === +item.tagId)?.name ??
            '-';

          return {
            ...item,
            fromDate: dateToFormat(new Date(item.fromDate), 'MM/dd/y'),
            toDate: formatToDate(item.fromDate, item.toDate),
            assetSelectionSet:
              assets?.find(
                (asset) => +asset.value === +item.assetSelectionSetId
              )?.label || '-',
            tagRefPropertyDefinition: propDef?.name || '-',
            propertyValue: propValue,
          };
        })
      : [],
    columns,
    actionDeleteRow,
  };
};
